import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dynamic-products_product" }
const _hoisted_2 = { class: "dynamic-products_product-content" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dynamic-products_product-image-overlay" }, null, -1)
const _hoisted_5 = { class: "dynamic-products_product-info" }
const _hoisted_6 = { class: "dynamic-products_product-name" }
const _hoisted_7 = {
  key: 0,
  class: "dynamic-products_product-price-original"
}
const _hoisted_8 = { class: "dynamic-products__product-favourite-icon" }

import { computed, inject } from 'vue';
  import { toLitiumMediaUrlKey } from '@distancify/drapejs-litium/lib/keys';

  import useContext from '@/composables/useContext';
  import { getWishlistProductContext } from '@/composables/useWishlist';

  import HeartIcon from '@/components/ProductCard/HeartIcon.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicProduct',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(__props) {

const props = __props

  

  const toLitiumMediaUrl = inject(toLitiumMediaUrlKey, (url: string, opts: any) => '');
  const { formatPrice } = useContext();

  const product = computed(() => props.product);
  const { isProductInWishlist, toggleProductInWishlist } = getWishlistProductContext(product);

  function getImageUrl() {
    return toLitiumMediaUrl(props.product.imageId, { maxWidth: 544 });
  }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "dynamic-products_product-a",
      to: _unref(product).url
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "dynamic-products_product-image",
            src: getImageUrl(),
            alt: _unref(product).name
          }, null, 8, _hoisted_3),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(product).name), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["dynamic-products_product-price", { 'dynamic-products_product-price--discounted': _unref(product).campaignPrice }])
            }, [
              _createTextVNode(_toDisplayString(_unref(formatPrice)(_unref(product).campaignPrice || _unref(product).unitPrice)) + " ", 1),
              (_unref(product).campaignPrice)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(formatPrice)(_unref(product).unitPrice)), 1))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(HeartIcon, {
              enableClickAnimation: true,
              preventClickBehavior: true,
              active: _unref(isProductInWishlist),
              onClick: _unref(toggleProductInWishlist)
            }, null, 8, ["active", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})